import React from "react";
import {
    TextInput,
    SelectInput,
    DateInput,
    ArrayInput,
    SimpleFormIterator
} from 'react-admin';
import required from "../helper/Required";
import CustomAddButton from "./CustomAddButton";
import CustomRemoveButton from "./CustomRemoveButton";

class EmployeeQualificationsArray extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayInput
                {...this.props}
            >
                <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                    <SelectInput label="Тип кваліфікації *" source="type"
                                 //validate={required.validateRequired}
                                 choices={[
                        // { id: 'CLINICAL_RESIDENCY', name: 'Клінічна ординатура' },
                        // { id: 'INFORMATION_COURSES', name: 'Курси інформації' },
                        // { id: 'INTERNSHIP', name: 'Інтернатура' },
                        { id: 'POSTGRADUATE', name: 'Аспірантура' },
                        { id: 'REATTESTATION', name: 'Передатестаційний цикл' },
                        { id: 'SPECIALIZATION', name: 'Курси спеціалізації' },
                        { id: 'STAZHUVANNYA', name: 'Стажування' },
                        // { id: 'TOPIC_IMPROVEMENT', name: 'Курси удосконалення' }
                    ]} />
                    <TextInput label="Навчальний заклад *" source="institutionName"
                               //validate={required.validateRequired}
                    />
                    <TextInput label="Вказати спеціальність *" source="speciality"
                              // validate={required.validateRequired}
                    />
                    <DateInput label="Дата отримання сертифікату *" source="issuedDate"
                               //validate={required.validateRequiredDate}
                    />
                    <TextInput label="Номер сертифікату *" source="certificateNumber"
                               //validate={required.validateRequired}
                    />
                    <DateInput label="Дійсний до *" source="validTo"
                               //validate={required.validateRequiredDate}
                    />
                </SimpleFormIterator>
            </ArrayInput>
        );
    }
}

export default EmployeeQualificationsArray;
